import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';

/**
 * NameFormコンポーネント用のPropsです。
 * @interface NameFormProps
 */
interface NameFormProps {

  /**
   * 氏名又は名称
   * @type {InputFieldState}
   * @memberof NameFormProps
   */
  name: InputFieldState;

  /**
   * 代理人フラグ
   * @type {boolean}
   * @memberof NameFormProps
   */
  isAgency: boolean;

  /**
   * 氏名又は名称を設定する関数
   * @memberof NameFormProps
   */
  onChange: (name: InputFieldState) => void;
}

/**
 * 氏名又は名称フォームのコンポーネントです。
 * @param {string} props.name - 表示する氏名又は名称
 * @param {function} props.onChange - 氏名又は名称が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 氏名又名称フォームのJSX要素
 */
const NameForm: React.FC<NameFormProps> = ({ name, isAgency, onChange }) => {

  /**
   * フォームの変更イベントハンドラーです。
   * 入力された氏名又は名称をonChange関数を呼び出します。
   * @param {object} event - フォームの変更イベント
   * @returns {void}
   */
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const pattern = /弁護士・外国法事務弁護士共同法人/;
    const value = halfWidthToFullWidth(event.target.value);
    onChange({
      value: value,
      errorMessage: value.trim() === '' ? '氏名又は名称が入力されていません。' : (isAgency && value.match(pattern )? '手続者に弁護士・外国法事務弁護士共同法人を入力することはできません（本ツール対象外）。' : '')
    });
  };

  /**
   * 半角文字を全角文字に変換する
   * @param {String} inputValue 変換対象の半角文字列
   * @return {String} 全角変換した文字列
   */
  const halfWidthToFullWidth = (inputValue: string) => {
    const fullWidthValue = inputValue.replace(/[A-Za-z0-9]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
    });

    return fullWidthValue
      .replace(/"/g, "”")
      .replace(/'/g, "’")
      .replace(/`/g, "‘")
      .replace(/\\/g, "￥")
      .replace(/ /g, "　")
      .replace(/~/g, "〜")
      .replace(/-/g, "−");
  };

  return (
    <Form.Group className="mb-2 row">
      <Form.Label className="col-lg-2 col-12 d-flex align-items-center">
        氏名又は名称
        <span className="text-small text-danger ms-3">※必須</span>
      </Form.Label>
      <div className="col-lg-10 col-12">
        <Form.Control
          type="text"
          value={name.value}
          placeholder="氏名又は名称を入力してください。（例：特許　太郎）"
          onChange={handleChange}
          aria-label="氏名又は名称"
          isInvalid={name.errorMessage !== ''}
        />
        <div className="text-end text-danger small" data-testid="name-form">{name.errorMessage !== '' ? name.errorMessage : ''}</div>
      </div>
    </Form.Group>
  );
};

export default NameForm;